    <template>
  <div class="table-tab a-width-100-percent" v-if="pages.length > 1">
    <div class="table-tab__nav">
      <nav>
        <ul class="pagination">
          <li class="page-item prev" :disabled="!hasPrevPage">
            <span class="page-link" @click.prevent="onPrevPageClick">
              <img src="@/assets/img/static/arrow-next-prev.png" alt="">
            </span>
          </li>
          <li class="page-item"
              :class="{'active': id === page}"
              v-for="id in pages">
            <span class="page-link" @click="onFilterChanged(id, pageSize)">
              {{id}}
            </span>
          </li>
          <li class="page-item next" :disabled="!hasNextPage">
            <span class="page-link" @click.prevent="onNextPageClick">
              <img src="@/assets/img/static/arrow-next-prev.png" alt="">
            </span>
          </li>
        </ul>
      </nav>
      <div class="admin-buy__show-item">
        <p>{{$t('labels.show-by')}}</p>
        <dropdown-new class="select-w-77"
                      :options="pageSizes"
                      v-model="currentPageSize">
        </dropdown-new>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Pagination",

    props: {
      count: {
        type: Number,
        required: true
      },

      sizes: {
        type: Array,
        required: true
      },

      page: {
        type: Number,
        default: 1
      },

      pageSize: {
        type: Number,
        default: 1
      }
    },

    computed: {
      nbOfPages() {
        return Math.ceil(this.count / this.pageSize);
      },

      hasPrevPage() {
        return this.page > 1;
      },

      hasNextPage() {
        return this.page < this.nbOfPages;
      },

      pageSizes() {
        return this.sizes.filter(v => v <= this.count).map(e => ({
          id: e,
          name: e
        }));
      },

      pages() {
        const pages = [];
        const max = Math.min(this.nbOfPages, this.page + 5);
        for (let i = Math.max(this.page - 5, 1); i <= max; ++i) {
          pages.push(i);
        }

        return pages;
      },

      currentPageSize: {
        get() {
          return this.pageSize;
        },

        set(size) {
          this.onFilterChanged(1, size);
        }
      }
    },

    methods: {
      onFilterChanged(page, size) {
        this.$emit('change', {
          page: page,
          pageSize: size
        })
      },

      onPrevPageClick() {
        this.onFilterChanged(Math.max(this.page - 1, 1), this.pageSize);
      },

      onNextPageClick() {
        this.onFilterChanged(Math.min(this.page + 1, this.nbOfPages), this.pageSize);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page-item {
    cursor: pointer;

    &[disabled] {
      opacity: 0.5;
      cursor: auto
    }

    &.active {
      cursor: auto;
    }
  }
</style>
